var App = App || {};

(function ($){
	var $body,
			OCE;

	// *** READY ***
	$(document).ready(function() {
			// Staticizzo variabili $ (in modo da evitare continue intrusioni nel dom)
			$body = $('body');
			commonFnHandler();
			App.triggerEvent('main::appReady')
	});

	const commonFnHandler = () => {
		setBrowserClass();
		initSmartListener();
		setVHFix();

		OCE = gajus.orientationchangeend({});
		// Attach event listener to the "orientationchangeend" event.
		OCE.on('orientationchangeend', () => {
			setVHFix();
		});
	}

	const setBrowserClass = () => {
		const ua = window.navigator.userAgent;
		if(ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0){
			$('html').addClass('ie');
		}
		if(ua.indexOf('Edge/') > 0){
			$('html').addClass('edge');
		}
	}

	const initSmartListener = () => {
		const smartScroll = App.throttle(function() { App.triggerEvent("main::smartScroll"); }, 200);
		const smartResize = App.debounce(function() { App.triggerEvent("main::smartResize"); }, 250);
    $(window).on('scroll', smartScroll);
		$(window).on('resize', smartResize);
  }

	const setVHFix = () => {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh+'px');
  }

})(jQuery);
